module.exports = __webpack_public_path__ + "static/media/logo.4433169b.jpg";